import { Injectable } from '@angular/core';
import { DbRecord } from './db-record'
import { ArcService } from './arc.service'
import { UtilsService } from './utils.service'
import { Note } from './note'
import { RuntimeService } from './runtime.service'
import { Project } from './project'
import { ProjectService } from './project.service'
import { Observable }  from 'rxjs/Observable';
import { Topic } from './topic'

@Injectable()
export class NoteService {
  editModeNote: Note


  constructor(
    private arcs: ArcService,
    private utils: UtilsService,
    private rs: RuntimeService,
    private projects: ProjectService
  ) {
    this.projects.ns = this
  }

  newFromSaved(p: Project, params: Object) {
    Object.keys(params).forEach((k) => {
      let obj = params[k]
      this.createNote({
        id: k,
        parentId: obj['parentId'],
        project: p,
        text: obj['text'],
        date: new Date(obj['date'])
      })
    })
  }


  createNote(obj: Object) {
    return new Note(obj['id'],
      obj['parentId'],
      obj['project'],
      obj['text'],
      obj['date'],
      obj['topic']
    )
  }

  newNote(itm: DbRecord, topic?: Topic) {
    return this.createNote({
      id: this.utils.uniqueIdentifier,
      parentId: itm.id,
      topic: topic,
      project: this.rs.currentProject,
      text: '',
      date: new Date()
    })
  }

  removeNote(dbRecord?: DbRecord) {

  }

  save(note: Note): Observable<any> {
    let params = note.saveParams
    if (params['isTopicNote'])
      return this.projects.saveDbRecordTopic(this.rs.currentProject,
      params['dbRecordId'],
      params['topicId'],
      [note.text, note.date])
    let obs = this.arcs.run(params)
    obs.subscribe((x) => console.log(135, x))
    return obs
  }

  delete(note: Note): Observable<any> {
    let obs = this.arcs.run(note.deleteParams)
    obs.subscribe((x) => {
      if (x['isSuccess'])
        note.project.notesMap.delete(note.parentId)
    })
    return obs
  }

}



// WEBPACK FOOTER //
// ./src/app/note.service.ts